import React from 'react';
import { InputLabel, Date } from '@weezevent/nacre';
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';
import moment from 'moment-timezone';

export default function DateInput({ date, onChange = () => {}, onClick = () => {} }) {
    const locale = i18n.language;
    const { t } = useTranslation();

    const handleChange = React.useCallback(
        value => {
            if (value === null) {
                return onChange('orderDate', moment()), onChange('orderDateModified', false); // eslint-disable-line
            }
            return onChange('orderDate', moment(value, 'DD-MM-YYYY')), onChange('orderDateModified', true); // eslint-disable-line
        },
        [onChange]
    );

    return (
        <>
            <InputLabel label={t('attendees.addAttendees.orderDate')} />
            <Date.Input onClickTrigger={onClick} locale={locale} language={locale} value={date} format="date-numeric" returnFormat={'DD-MM-YYYY'} onChange={handleChange} />
        </>
    );
}
